<app-profile-header [firstName]="user().first_name!" [lastName]="user().last_name!" />
<div class="authlist">
  <app-row (click)="navigate('edit-profile')" [custom]="true" icon="c2u-person" label="Personal Info" />
  <app-row (click)="navigate('medical-profiles')" [custom]="true" icon="c2u-medical-profile" label="Medical Profiles" />
  <app-row (click)="navigate('payments-coupons')" [custom]="true" icon="c2u-wallet" label="Wallet" />
  @if (onMobile()) {
    <app-row (click)="navigate('biometrics')" icon="finger-print-outline" label="Biometrics" />
    <app-row (click)="navigate('device-permissions')" icon="phone-portrait-sharp" label="Device Permissions" />
  }
  <app-row (click)="navigate('settings')" [custom]="true" icon="c2u-settings" label="Settings" />
  <app-row (click)="getHelp()" [custom]="true" icon="c2u-help" label="Help" />
  <app-row (click)="logout()" [custom]="true" icon="c2u-exit" [border]="false" color="secondary" [arrow]="false" label="Log Out" />
</div>